import { useEffect } from 'react';

import { RadioButtonUnchecked } from '@mui/icons-material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import FormControlLabel from '@mui/material/FormControlLabel';
import Grid from '@mui/material/Grid2';
import Radio from '@mui/material/Radio';
import PropTypes from 'prop-types';
import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { DEFAULT_COMMUNITY_SOLR_VERSION } from './constants';
import EnterpriseCard from './EnterpriseCard';
import { StyledRadioGroup } from './InstanceStepper.styles';
import PlanCard from './PlanCard';
import StepTitle from './StepTitle';
import { INSTANCE_CATEGORY, PLAN_LIST } from '../../../constants';

const Plan = ({ community }) => {
  const { t } = useTranslation();
  const { control, setValue, watch } = useFormContext();

  useEffect(() => {
    if (watch('plan') !== INSTANCE_CATEGORY.COMMUNITY) return;
    setValue('solrVersion', DEFAULT_COMMUNITY_SOLR_VERSION.value);
  }, [watch('plan')]);

  // Maximum community instances allowed: 2
  const communityAvailable = community < 2;

  return (
    <section>
      <StepTitle title={t('selectPlan', { ns: 'descriptions' })} />
      <Controller
        name="plan"
        control={control}
        render={({ field }) => (
          <StyledRadioGroup aria-label="plan selection" {...field}>
            <Grid container spacing={2}>
              {PLAN_LIST.map((plan) => (
                <Grid
                  key={plan.name}
                  sx={{ display: 'flex' }}
                  size={{
                    xs: 12,
                    sm: 6,
                    md: 3,
                  }}
                >
                  <FormControlLabel
                    value={
                      plan.category === INSTANCE_CATEGORY.COMMUNITY
                        ? plan.category
                        : plan.type
                    }
                    control={
                      <Radio
                        style={{ color: 'white' }}
                        checkedIcon={<CheckCircleIcon />}
                        icon={
                          plan.category !== INSTANCE_CATEGORY.COMMUNITY ? (
                            <RadioButtonUnchecked />
                          ) : communityAvailable ? (
                            <RadioButtonUnchecked />
                          ) : (
                            <></>
                          )
                        }
                        disabled={
                          plan.category === INSTANCE_CATEGORY.COMMUNITY &&
                          !communityAvailable
                        }
                      />
                    }
                    label={<PlanCard plan={plan} community={community} />}
                  />
                </Grid>
              ))}
            </Grid>
          </StyledRadioGroup>
        )}
      />
      <EnterpriseCard />
    </section>
  );
};

Plan.propTypes = {
  community: PropTypes.number.isRequired,
};

export default Plan;
